import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        nav: {
          home: "Home",
          catalog: "Catalog",
          contact: "Contact Us",
          categories: "Categories",
          logout: "Log out",
          language: "Language",
          blog: "Blog",
          blogAdmin: "Blog Posts",
        },
        home: {
          hero: {
            headline: "Veterinary Lab Solutions for the Baltic States",
            tagline: "High-quality analyzers, diagnostics, and care products — trusted by veterinary clinics across Estonia, Latvia, and Lithuania.",
            reasons: [
              "Solutions for labs of all sizes and experience levels",
              "Balance of high quality and affordable pricing",
              "Direct partnerships with trusted manufacturers",
            ],
          },
          whatWeSell: {
            title: "What We Sell",
            description: "We offer a wide range of high-level veterinary equipment that covers all daily analysis needs of veterinary laboratories and ensures accurate and reliable results. Our products include:",
            items: [
              "Blood analyzers: High-tech and easy-to-use devices that provide quick blood analysis and reliable results.",
              "Urine analyzers: Optimized devices that enable precise urine analysis and quick results.",
              "Laboratory accessories: Equipment for sample preparation and test conduction.",
              "Reagents and supplies: All the necessary accessories that ensure the reliability and accuracy of the equipment.",
              "Quick tests: Fast and reliable tests for rapid assessment of animal health.",
              "Care products: We offer high-quality skin treatment products, including ointments, creams, and shampoos, that help maintain the health of animals' skin and fur.",
            ],
          },
          mission: {
            title: "Mission",
            description: "Our mission is to support the development of veterinary clinics in the Baltic States by providing state-of-the-art laboratory solutions that help improve animal healthcare quality and enable fast and accurate diagnostics.",
          },
          vision: {
            title: "Vision",
            description: "Our vision is to be the leading partner in the veterinary sector in the Baltic States, offering innovative and high-tech solutions that help clinics provide comprehensive, reliable, and high-quality services, ensuring the best tools for the future of animal healthcare.",
          },
          values: {
            title: "Values",
            items: [
              "Reliability and accuracy – Quality you can trust.",
              "Flexibility – Solutions that adapt to your needs.",
              "Speed – Fast support and efficiency.",
              "Balance of price and quality – The best value for every investment.",
            ],
          },
          featured: {
            title: "Featured Products",
          },
        },
        catalog: {
          breadcrumb: "Catalog",
          backTo: "Back to {{category}}",
        },
        blog: {
          title: "Blog",
          subtitle: "News from Lutsero: conferences we visit, new products and company events.",
          empty: "No posts yet — check back soon.",
          backToBlog: "Back to blog",
          notFound: "Post not found.",
        },
        cart: {
          title: "Your Cart",
          empty: "Your cart is empty",
          browseCatalog: "Browse catalog",
          sendEnquiry: "Send Enquiry",
          clearCart: "Clear Cart",
          addToCart: "Add to Cart",
          removeFromCart: "Remove from Cart",
        },
        contact: {
          description: "If you have any questions or need more information about our products and services, please feel free to contact us. We are here to help you find the best solutions for your veterinary laboratory needs.",
          form: {
            name: "Name",
            email: "Email",
            subject: "Subject",
            message: "Message",
            sendButton: "Send",
            sendingButton: "Sending...",
            enquiryIncludes: "Your enquiry includes:",
            successMessage: "Your message has been sent successfully!",
            errorMessage: "There was an error sending your message. Please try again later.",
          },
        },
        footer: {
          tagline: "Veterinary lab solutions for the Baltic States.",
          quickLinks: "Quick Links",
          rights: "All rights reserved.",
        },
      },
    },
    et: {
      translation: {
        nav: {
          home: "Kodu",
          catalog: "Kataloog",
          contact: "Võta Ühendust",
          categories: "Kategooriad",
          logout: "Logi välja",
          language: "Keel",
          blog: "Blogi",
          blogAdmin: "Blogipostitused",
        },
        home: {
          hero: {
            headline: "Veterinaarlabori lahendused Baltimaadele",
            tagline: "Kvaliteetsed analüsaatorid, diagnostika ja hooldustooted — usaldusväärne partner veterinaarkliinikutele üle Baltikumi.",
            reasons: [
              "Lahendused erineva suuruse ja kogemusega laboritele",
              "Kõrge kvaliteedi ja taskukohase hinna tasakaal",
              "Otsekoostöö usaldusväärsete tootjatega",
            ],
          },
          whatWeSell: {
            title: "Mida me müüme",
            description: "Pakume laias valikus kõrgtasemel veterinaarseadmeid, mis katab kõik veterinaarlaborite igapäevased analüüsivajadused ja tagab täpsed ning usaldusväärsed tulemused. Meie tooted sisaldavad:",
            items: [
              "Vereanalüsaatorid: Kõrgtehnoloogilised ja lihtsasti kasutatavad seadmed, mis pakuvad kiiret vereanalüüsi ning tagavad usaldusväärsed tulemused.",
              "Uriinianalüsaatorid: Optimeeritud seadmed, mis võimaldavad täpset uriinianalüüsi ja kiiret tulemuste saamist.",
              "Labori lisaseadmed: Seadmed proovide ettevalmistamiseks ja testide läbiviimiseks.",
              "Reagendid ja tarvikud: Kõik vajalikud tarvikud, mis tagavad seadmete töökindluse ja täpsuse.",
              "Kiirtestid: Kiired ja usaldusväärsed testid loomade tervise kiireks hindamiseks.",
              "Hooldustooted: Pakume kvaliteetseid naharavivahendeid, sealhulgas salve, kreeme ja šampoone, mis aitavad hoida loomade naha ja karvkatte tervist.",
            ],
          },
          mission: {
            title: "Missioon",
            description: "Meie missioon on toetada veterinaarkliinikute arengut Baltimaades, pakkudes tipptasemel laborilahendusi, mis aitavad tõsta loomade tervishoiu kvaliteeti ning võimaldavad kiiret ja täpset diagnoosimist.",
          },
          vision: {
            title: "Visioon",
            description: "Meie visioon on olla Baltimaades juhtiv partner veterinaarsektoris, pakkudes innovatiivseid ja kõrgtehnoloogilisi lahendusi, mis aitavad kliinikutele pakkuda komplekseid, usaldusväärset ja kvaliteetset teenust, kindlustades loomade tervishoiu tulevikuks parimad tööriistad.",
          },
          values: {
            title: "Väärtused",
            items: [
              "Usaldusväärsus ja täpsus – Kvaliteet, millele saab kindel olla.",
              "Paindlikkus – Lahendused, mis kohanduvad teie vajadustega.",
              "Kiirus – Kiire tugi ja tõhusus.",
              "Hinna ja kvaliteedi tasakaal – Parim väärtus igas investeeringus.",
            ],
          },
          featured: {
            title: "Esitletud tooted",
          },
        },
        catalog: {
          breadcrumb: "Kataloog",
          backTo: "Tagasi: {{category}}",
        },
        blog: {
          title: "Blogi",
          subtitle: "Lutsero uudised: konverentsid, uued tooted ja ettevõtte sündmused.",
          empty: "Postitusi veel pole — vaata peagi uuesti.",
          backToBlog: "Tagasi blogisse",
          notFound: "Postitust ei leitud.",
        },
        cart: {
          title: "Teie ostukorv",
          empty: "Ostukorv on tühi",
          browseCatalog: "Sirvi kataloogi",
          sendEnquiry: "Saada päring",
          clearCart: "Tühjenda ostukorv",
          addToCart: "Lisa ostukorvi",
          removeFromCart: "Eemalda ostukorvist",
        },
        contact: {
          description: "Kui teil on küsimusi või vajate lisateavet meie toodete ja teenuste kohta, võtke meiega julgelt ühendust. Aitame teil leida parimad lahendused teie veterinaarlabori vajaduste jaoks.",
          form: {
            name: "Nimi",
            email: "E-post",
            subject: "Teema",
            message: "Sõnum",
            sendButton: "Saada",
            sendingButton: "Saatmine...",
            enquiryIncludes: "Teie päring sisaldab:",
            successMessage: "Teie sõnum on edukalt saadetud!",
            errorMessage: "Sõnumi saatmisel tekkis viga. Palun proovige hiljem uuesti.",
          },
        },
        footer: {
          tagline: "Veterinaarlabori lahendused Baltimaadele.",
          quickLinks: "Kiirlingid",
          rights: "Kõik õigused kaitstud.",
        },
      },
    },
    ru: {
      translation: {
        nav: {
          home: "Главная",
          catalog: "Каталог",
          contact: "Связаться",
          categories: "Категории",
          logout: "Выйти",
          language: "Язык",
          blog: "Блог",
          blogAdmin: "Записи блога",
        },
        home: {
          hero: {
            headline: "Ветеринарные лабораторные решения для стран Балтии",
            tagline: "Высококачественные анализаторы, диагностика и средства ухода — надёжный партнёр ветеринарных клиник Эстонии, Латвии и Литвы.",
            reasons: [
              "Решения для лабораторий любого размера и уровня опыта",
              "Баланс высокого качества и доступных цен",
              "Прямое сотрудничество с проверенными производителями",
            ],
          },
          whatWeSell: {
            title: "Что мы продаем",
            description: "Наше основное направление – решения для ветеринарных лабораторий. Мы предлагаем широкий ассортимент высококачественного ветеринарного оборудования, которое покрывает все ежедневные потребности ветеринарных лабораторий и гарантирует точные и надежные результаты. Наши продукты включают:",
            items: [
              "Анализаторы крови: Высокотехнологичные и простые в использовании устройства, которые обеспечивают быстрый анализ крови и надежные результаты.",
              "Анализаторы мочи: Оптимизированные устройства для точного анализа мочи и получения быстрых результатов.",
              "Лабораторные аксессуары: Оборудование для подготовки образцов и проведения анализов.",
              "Реагенты и расходные материалы: Все необходимые материалы для обеспечения точности и бесперебойной работы оборудования.",
              "Экспресс-тесты: Быстрые и надежные тесты для оценки здоровья животных.",
              "Средства ухода: Мы предлагаем качественные средства для лечения кожи, включая мази, кремы и шампуни, которые помогают поддерживать здоровье кожи и шерсти животных.",
            ],
          },
          mission: {
            title: "Миссия",
            description: "Наша миссия – поддерживать развитие ветеринарных клиник в странах Балтии,  предоставляя современные лабораторные решения, которые помогают улучшить качество ветеринарного обслуживания и обеспечивают быструю и точную диагностику.",
          },
          vision: {
            title: "Видение",
            description: "Наша цель – стать ведущим партнером в ветеринарной отрасли в странах Балтии, предлагая инновационные и высокотехнологичные решения, которые помогают клиникам предоставлять комплексные, надежные и качественные услуги, обеспечивая лучшие решения для лечения и сохранения здоровья животных.",
          },
          values: {
            title: "Ценности",
            items: [
              "Надежность – качество, которому можно доверять.",
              "Гибкость – индивидуальный подход.",
              "Скорость – быстрая поддержка и высокая эффективность.",
              "Идеальный баланс цены и качества – идеальное соотношение стоимости и содержания, премиальности и точности высоких стандартов.",
            ],
          },
          featured: {
            title: "Рекомендуемые товары",
          },
        },
        catalog: {
          breadcrumb: "Каталог",
          backTo: "Назад: {{category}}",
        },
        blog: {
          title: "Блог",
          subtitle: "Новости Lutsero: конференции, новые продукты и события компании.",
          empty: "Пока нет записей — загляните позже.",
          backToBlog: "Назад к блогу",
          notFound: "Запись не найдена.",
        },
        cart: {
          title: "Ваша корзина",
          empty: "Корзина пуста",
          browseCatalog: "Смотреть каталог",
          sendEnquiry: "Отправить запрос",
          clearCart: "Очистить корзину",
          addToCart: "Добавить в корзину",
          removeFromCart: "Убрать из корзины",
        },
        contact: {
          description: "Если у вас есть вопросы или вам нужна дополнительная информация о нашей продукции и услугах, пожалуйста, свяжитесь с нами. Мы поможем вам найти лучшие решения для вашей ветеринарной лаборатории.",
          form: {
            name: "Имя",
            email: "Электронная почта",
            subject: "Тема",
            message: "Сообщение",
            sendButton: "Отправить",
            sendingButton: "Отправка...",
            enquiryIncludes: "Ваш запрос включает:",
            successMessage: "Ваше сообщение было успешно отправлено!",
            errorMessage: "Произошла ошибка при отправке сообщения. Пожалуйста, попробуйте позже.",
          },
        },
        footer: {
          tagline: "Ветеринарные лабораторные решения для стран Балтии.",
          quickLinks: "Быстрые ссылки",
          rights: "Все права защищены.",
        },
      },
    },
    lv: {
      translation: {
        nav: {
          home: "Sākums",
          catalog: "Katalogs",
          contact: "Sazināties",
          categories: "Kategorijas",
          logout: "Iziet",
          language: "Valoda",
          blog: "Blogs",
          blogAdmin: "Bloga ieraksti",
        },
        home: {
          hero: {
            headline: "Veterinārās laboratorijas risinājumi Baltijas valstīm",
            tagline: "Augstas kvalitātes analizatori, diagnostika un kopšanas līdzekļi — uzticams partneris veterinārajām klīnikām Igaunijā, Latvijā un Lietuvā.",
            reasons: [
              "Risinājumi dažāda lieluma un pieredzes laboratorijām",
              "Augstas kvalitātes un pieejamas cenas līdzsvars",
              "Tieša sadarbība ar uzticamiem ražotājiem",
            ],
          },
          whatWeSell: {
            title: "Ko mēs piedāvājam",
            description: "Mēs piedāvājam plašu augsta līmeņa veterinārā aprīkojuma klāstu, kas aptver visas veterināro laboratoriju ikdienas analīžu vajadzības un nodrošina precīzus un uzticamus rezultātus. Mūsu produkti ietver:",
            items: [
              "Asins analizatori: Augsto tehnoloģiju un viegli lietojamas ierīces, kas nodrošina ātru asins analīzi un uzticamus rezultātus.",
              "Urīna analizatori: Optimizētas ierīces, kas ļauj veikt precīzu urīna analīzi un ātri iegūt rezultātus.",
              "Laboratorijas piederumi: Aprīkojums paraugu sagatavošanai un testu veikšanai.",
              "Reaģenti un palīgmateriāli: Visi nepieciešamie piederumi, kas nodrošina aprīkojuma uzticamību un precizitāti.",
              "Ātrie testi: Ātri un uzticami testi dzīvnieku veselības operatīvai novērtēšanai.",
              "Kopšanas līdzekļi: Mēs piedāvājam kvalitatīvus ādas kopšanas līdzekļus, tostarp ziedes, krēmus un šampūnus, kas palīdz uzturēt dzīvnieku ādas un apmatojuma veselību.",
            ],
          },
          mission: {
            title: "Misija",
            description: "Mūsu misija ir atbalstīt veterināro klīniku attīstību Baltijas valstīs, piedāvājot modernus laboratorijas risinājumus, kas palīdz uzlabot dzīvnieku veselības aprūpes kvalitāti un nodrošina ātru un precīzu diagnostiku.",
          },
          vision: {
            title: "Vīzija",
            description: "Mūsu vīzija ir būt vadošajam partnerim veterinārajā nozarē Baltijas valstīs, piedāvājot inovatīvus un augsto tehnoloģiju risinājumus, kas palīdz klīnikām sniegt visaptverošus, uzticamus un kvalitatīvus pakalpojumus, nodrošinot labākos rīkus dzīvnieku veselības aprūpes nākotnei.",
          },
          values: {
            title: "Vērtības",
            items: [
              "Uzticamība un precizitāte – kvalitāte, kurai var uzticēties.",
              "Elastība – risinājumi, kas pielāgojas jūsu vajadzībām.",
              "Ātrums – ātrs atbalsts un efektivitāte.",
              "Cenas un kvalitātes līdzsvars – labākā vērtība katrā ieguldījumā.",
            ],
          },
          featured: {
            title: "Izceltie produkti",
          },
        },
        catalog: {
          breadcrumb: "Katalogs",
          backTo: "Atpakaļ: {{category}}",
        },
        blog: {
          title: "Blogs",
          subtitle: "Lutsero jaunumi: konferences, jauni produkti un uzņēmuma notikumi.",
          empty: "Ierakstu vēl nav — ieskatieties vēlāk.",
          backToBlog: "Atpakaļ uz blogu",
          notFound: "Ieraksts nav atrasts.",
        },
        cart: {
          title: "Jūsu grozs",
          empty: "Jūsu grozs ir tukšs",
          browseCatalog: "Pārlūkot katalogu",
          sendEnquiry: "Nosūtīt pieprasījumu",
          clearCart: "Iztukšot grozu",
          addToCart: "Pievienot grozam",
          removeFromCart: "Izņemt no groza",
        },
        contact: {
          description: "Ja jums ir kādi jautājumi vai nepieciešama papildu informācija par mūsu produktiem un pakalpojumiem, lūdzu, sazinieties ar mums. Mēs palīdzēsim jums atrast labākos risinājumus jūsu veterinārās laboratorijas vajadzībām.",
          form: {
            name: "Vārds",
            email: "E-pasts",
            subject: "Temats",
            message: "Ziņojums",
            sendButton: "Nosūtīt",
            sendingButton: "Sūta...",
            enquiryIncludes: "Jūsu pieprasījumā iekļauts:",
            successMessage: "Jūsu ziņojums ir veiksmīgi nosūtīts!",
            errorMessage: "Nosūtot ziņojumu, radās kļūda. Lūdzu, mēģiniet vēlreiz vēlāk.",
          },
        },
        footer: {
          tagline: "Veterinārās laboratorijas risinājumi Baltijas valstīm.",
          quickLinks: "Ātrās saites",
          rights: "Visas tiesības aizsargātas.",
        },
      },
    },
    lt: {
      translation: {
        nav: {
          home: "Pradžia",
          catalog: "Katalogas",
          contact: "Susisiekite",
          categories: "Kategorijos",
          logout: "Atsijungti",
          language: "Kalba",
          blog: "Tinklaraštis",
          blogAdmin: "Tinklaraščio įrašai",
        },
        home: {
          hero: {
            headline: "Veterinarinių laboratorijų sprendimai Baltijos šalims",
            tagline: "Aukštos kokybės analizatoriai, diagnostika ir priežiūros priemonės — patikimas veterinarijos klinikų partneris Estijoje, Latvijoje ir Lietuvoje.",
            reasons: [
              "Sprendimai įvairaus dydžio ir patirties laboratorijoms",
              "Aukštos kokybės ir prieinamos kainos pusiausvyra",
              "Tiesioginė partnerystė su patikimais gamintojais",
            ],
          },
          whatWeSell: {
            title: "Ką siūlome",
            description: "Siūlome platų aukšto lygio veterinarinės įrangos asortimentą, kuris apima visus kasdienius veterinarijos laboratorijų tyrimų poreikius ir užtikrina tikslius bei patikimus rezultatus. Mūsų produktai apima:",
            items: [
              "Kraujo analizatoriai: Aukštųjų technologijų ir paprastai naudojami prietaisai, užtikrinantys greitą kraujo tyrimą ir patikimus rezultatus.",
              "Šlapimo analizatoriai: Optimizuoti prietaisai, leidžiantys atlikti tikslų šlapimo tyrimą ir greitai gauti rezultatus.",
              "Laboratoriniai priedai: Įranga mėginiams paruošti ir tyrimams atlikti.",
              "Reagentai ir eksploatacinės medžiagos: Visos reikalingos priemonės, užtikrinančios įrangos patikimumą ir tikslumą.",
              "Greitieji testai: Greiti ir patikimi testai skubiam gyvūnų sveikatos įvertinimui.",
              "Priežiūros priemonės: Siūlome kokybiškas odos priežiūros priemones, įskaitant tepalus, kremus ir šampūnus, padedančius palaikyti gyvūnų odos ir kailio sveikatą.",
            ],
          },
          mission: {
            title: "Misija",
            description: "Mūsų misija – remti veterinarijos klinikų plėtrą Baltijos šalyse, teikiant modernius laboratorinius sprendimus, kurie padeda gerinti gyvūnų sveikatos priežiūros kokybę ir užtikrina greitą bei tikslią diagnostiką.",
          },
          vision: {
            title: "Vizija",
            description: "Mūsų vizija – būti pirmaujančiu partneriu Baltijos šalių veterinarijos sektoriuje, siūlant inovatyvius ir aukštųjų technologijų sprendimus, kurie padeda klinikoms teikti visapusiškas, patikimas ir kokybiškas paslaugas, užtikrinant geriausias priemones gyvūnų sveikatos priežiūros ateičiai.",
          },
          values: {
            title: "Vertybės",
            items: [
              "Patikimumas ir tikslumas – kokybė, kuria galite pasitikėti.",
              "Lankstumas – sprendimai, prisitaikantys prie jūsų poreikių.",
              "Greitis – greita pagalba ir efektyvumas.",
              "Kainos ir kokybės pusiausvyra – geriausia vertė kiekvienai investicijai.",
            ],
          },
          featured: {
            title: "Rekomenduojami produktai",
          },
        },
        catalog: {
          breadcrumb: "Katalogas",
          backTo: "Atgal: {{category}}",
        },
        blog: {
          title: "Tinklaraštis",
          subtitle: "Lutsero naujienos: konferencijos, nauji produktai ir įmonės renginiai.",
          empty: "Įrašų dar nėra — užsukite vėliau.",
          backToBlog: "Atgal į tinklaraštį",
          notFound: "Įrašas nerastas.",
        },
        cart: {
          title: "Jūsų krepšelis",
          empty: "Jūsų krepšelis tuščias",
          browseCatalog: "Naršyti katalogą",
          sendEnquiry: "Siųsti užklausą",
          clearCart: "Išvalyti krepšelį",
          addToCart: "Įdėti į krepšelį",
          removeFromCart: "Pašalinti iš krepšelio",
        },
        contact: {
          description: "Jei turite klausimų ar jums reikia daugiau informacijos apie mūsų produktus ir paslaugas, nedvejodami susisiekite su mumis. Padėsime rasti geriausius sprendimus jūsų veterinarijos laboratorijos poreikiams.",
          form: {
            name: "Vardas",
            email: "El. paštas",
            subject: "Tema",
            message: "Žinutė",
            sendButton: "Siųsti",
            sendingButton: "Siunčiama...",
            enquiryIncludes: "Jūsų užklausoje:",
            successMessage: "Jūsų žinutė sėkmingai išsiųsta!",
            errorMessage: "Siunčiant žinutę įvyko klaida. Bandykite dar kartą vėliau.",
          },
        },
        footer: {
          tagline: "Veterinarinių laboratorijų sprendimai Baltijos šalims.",
          quickLinks: "Greitosios nuorodos",
          rights: "Visos teisės saugomos.",
        },
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;